import GuestViewDashboard from './GuestViewDashboardContainer';

export default GuestViewDashboard;